import DailyActivities from './daily-activities-view'
export default DailyActivities
